// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Table, Button, Glyphicon } from 'react-bootstrap';
import _ from 'lodash';
import { actionCreators } from '../../state/grids-dux';

//type Column = {
//  key: string,
//  title: string,
//  disableSorting: boolean,
//  headerStyle: Object,
//  headerClassName: any,
//  bodyProps: Object,
//  renderHeader: () => any,
//  renderBody: () => any
//};

type SortValues = {
  key: string,
  direction: 'asc' | 'desc'
};

// type PowerGridProps = {
//   columns: Array<Column>,
//   rows: Array<any>,
//   rowKey: string,
//   gridId: string,
//   gridState: any,
//   resetGrid: ({ gridId: string }) => void,
//   sortGrid: ({ gridId: string, values: SortValues }) => void
// };

const getDraggingStyle = ({ dragOver, draggingIndex, index, draggable }) => {
  if (!draggable) return {};
  if (!dragOver || draggingIndex === null) return { cursor: 'pointer' };
  if (index < draggingIndex) return { borderTop: '3px solid #1172cf', cursor: 'pointer' }
  return { borderBottom: '3px solid #1172cf', cursor: 'pointer' }
}

class RowComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { dragOver: false }
  }
  render() {
    const {
      rowKey,
      r,
      i,
      draggable,
      columns,
      onDragStart,
      onDragEnter,
      onDragLeave,
      onDrop,
      draggingIndex
    } = this.props;
    const {
      dragOver
    } = this.state;
    return (
      <tr
        key={rowKey ? r[rowKey] : i}
        style={getDraggingStyle({ draggingIndex, dragOver, index: i, draggable })}
        draggable={draggable}
        onDragStart={(e) => {
          if (!draggable) return;
          onDragStart(e, r, i)
        }}
        onDragOver={e => {
          if (!draggable) return;
          e.preventDefault()
        }}
        onDragEnter={e => {
          if (!draggable) return;
          e.preventDefault()
          this.setState({ dragOver: true })
          onDragEnter && onDragEnter(e);
        }}
        onDragLeave={e => {
          if (!draggable) return;
          e.preventDefault();
          this.setState({ dragOver: false })
          onDragLeave && onDragLeave(e);
        }}
        onDragExit={e => {
          if (!draggable) return;
          this.setState({ dragOver: false })
        }}
        onDrop={e => {
          if (!draggable) return;
          this.setState({ dragOver: false })
          onDrop(e, r, i);
        }}

      >
        {columns.map(c => (
          <td key={c.key} {...c.bodyProps}>
            {c.renderBody ? c.renderBody(r, r[c.key], c) : r[c.key]}
          </td>
        ))}
      </tr>
    )
  }
}

const SortButton = (
  { sortBy, columnKey: key, direction, gridId, sortGrid }
) => (
  <Button
    bsSize="xsmall"
    onClick={() => sortGrid({ gridId, values: { key, direction } })}
    disabled={sortBy && sortBy.key === key && sortBy.direction === direction}
  >
    <Glyphicon glyph={`arrow-${direction === 'asc' ? 'up' : 'down'}`} />
  </Button>
);

export class PowerGrid extends Component {
  constructor(props) {
    super(props);
    this.state = { draggingIndex: null }
  }
  componentWillMount() {
    const { gridId, resetGrid } = this.props;
    resetGrid({ gridId });
  }
  render() {
    const {
      columns,
      rows,
      rowKey,
      gridId,
      gridState,
      resetGrid,
      sortGrid,
      draggable,
      noSort,
      onDragStart,
      onDragEnter,
      onDragLeave,
      onDrop
    } = this.props;

    const { draggingIndex } = this.state;

    if (!gridId) {
      return;
    }

    const { sortBy }: { sortBy: SortValues } = gridState[gridId] || {};

    let rowSet = rows;
    if (sortBy) {
      rowSet = _.orderBy(rowSet, [sortBy.key], [sortBy.direction]);
    }

    const handleDragStart = (e, row, index) => {
      this.setState({ draggingIndex: index });
      onDragStart(e, row)
    }
    const handleDrop = (e, row, index) => {
      this.setState({ draggingIndex: null });
      onDrop(e, row, index)
    }

    return (
      <Table striped bordered condensed hover>
        <thead>
          <tr>
            {columns.map((c, i) => (
              <th
                style={Object.assign(
                  {},
                  { whiteSpace: 'nowrap' },
                  c.headerStyle
                )}
                {...c.headerProps}
                key={i}
              >
                {c.title} {' '}
                {!c.noSort && !noSort &&
                  <SortButton
                    {...{
                      sortBy,
                      gridId,
                      sortGrid,
                      columnKey: c.key,
                      direction: 'asc'
                    }}
                  />}
                {!c.noSort && !noSort &&
                  <SortButton
                    {...{
                      sortBy,
                      gridId,
                      sortGrid,
                      columnKey: c.key,
                      direction: 'desc'
                    }}
                  />}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rowSet.map((r, i) => (
            <RowComponent
              {...{
                rowKey,
                r,
                i,
                draggable,
                columns,
                onDragStart: handleDragStart,
                onDragEnter,
                onDragLeave,
                onDrop: handleDrop,
                draggingIndex
              }}
            />
          ))}
        </tbody>
      </Table>
    );
  }
}

const mapState = state => ({ gridState: state.grids.toJS() });
const mapDispatch = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapState, mapDispatch)(PowerGrid);



// WEBPACK FOOTER //
// ./src/components/ui/PowerGrid.js